export default "__VITE_ASSET__CAU8vYNi__"